import React from 'react';
import { useGame } from '../../contexts/GameContext';
import MainNavigation from '../../components/navigation/MainNavigation';
import PlayerStatusCard from './components/PlayerStatusCard';
import NavigationButton from './components/NavigationButton';
import AchievementTicker from './components/AchievementTicker';
import ProgressionIndicator from './components/ProgressionIndicator';
import QuickStatsPanel from './components/QuickStatsPanel';

const MainMenu = () => {
  const { getUserStats, currentStreak } = useGame();
  const userStats = getUserStats();

  const playerStats = {
    playerName: "CYBER_WARRIOR_X",
    currentStreak: currentStreak || 0,
    totalGems: userStats?.totalGems || 0,
    unlockedMoods: 3,
    totalMoods: 5,
    winRate: userStats?.totalGames > 0 
      ? Math.round((userStats?.totalWins / userStats?.totalGames) * 100) 
      : 0,
    totalGames: userStats?.totalGames || 0,
    bestStreak: userStats?.bestStreak || 0
  };

  const quickStats = {
    totalWins: userStats?.totalWins || 0,
    totalLosses: userStats?.totalLosses || 0,
    averageScore: 0,
    totalPlaytime: 0
  };

  const achievements = [
    {
      icon: "Trophy",
      title: "First Blood",
      description: "Won your first game against the AI. The psychological warfare begins.",
      timestamp: "2 hours ago"
    },
    {
      icon: "Flame",
      title: "Hot Streak",
      description: "Achieved a 5-game winning streak. The AI is getting nervous.",
      timestamp: "5 hours ago"
    },
    {
      icon: "Brain",
      title: "Mind Games Master",
      description: "Unlocked the Aggressive AI mood. Prepare for intense psychological battles.",
      timestamp: "1 day ago"
    },
    {
      icon: "Gem",
      title: "Gem Collector",
      description: "Collected 1000 gems. Your dedication to the grind is impressive.",
      timestamp: "2 days ago"
    },
    {
      icon: "Zap",
      title: "Speed Demon",
      description: "Won 3 consecutive games in under 30 seconds each. Lightning fast reflexes.",
      timestamp: "3 days ago"
    }
  ];

  const progression = {
    nextUnlock: {
      name: "CHAOS MOOD (RAGE PRO)",
      icon: "Skull",
      description: "Unlock the most aggressive AI variant. Extreme trash-talking and psychological pressure await."
    },
    currentProgress: userStats?.totalGems || 0,
    requiredProgress: 2000,
    gemRarity: "LEGENDARY",
    difficulty: "EXTREME"
  };

  const navigationButtons = [
    {
      icon: "Gamepad2",
      label: "START GAME",
      path: "/game-arena",
      variant: "primary",
      locked: false
    },
    {
      icon: "Brain",
      label: "AI MOODS",
      path: "/ai-mood-selection",
      variant: "secondary",
      locked: false
    },
    {
      icon: "Gem",
      label: "GEM COLLECTION",
      path: "/gem-collection",
      variant: "accent",
      locked: false
    },
    {
      icon: "BarChart3",
      label: "STATISTICS",
      path: "/statistics",
      variant: "primary",
      locked: true
    }
  ];

  return (
    <div className="main-menu min-h-screen bg-background">
      <MainNavigation />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
          <div className="mb-6 md:mb-8 lg:mb-12">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold neon-text-cyan mb-2 md:mb-3">
              MAIN TERMINAL
            </h1>
            <p className="text-sm md:text-base lg:text-lg font-caption text-muted-foreground tracking-wide">
              SELECT YOUR NEXT MOVE IN THE PSYCHOLOGICAL WARFARE
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10 mb-6 md:mb-8 lg:mb-10">
            <div className="lg:col-span-2 space-y-6 md:space-y-8">
              <PlayerStatusCard stats={playerStats} />
              
              <div className="grid grid-cols-2 gap-4 md:gap-6 lg:gap-8">
                {navigationButtons?.map((button, index) => (
                  <NavigationButton
                    key={index}
                    icon={button?.icon}
                    label={button?.label}
                    path={button?.path}
                    variant={button?.variant}
                    locked={button?.locked}
                  />
                ))}
              </div>

              <QuickStatsPanel stats={quickStats} />
            </div>

            <div className="space-y-6 md:space-y-8">
              <AchievementTicker achievements={achievements} />
              <ProgressionIndicator progression={progression} />
            </div>
          </div>

          <div className="bg-card border border-primary/30 rounded-sm p-4 md:p-5 lg:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-2 h-2 bg-accent rounded-sm animate-pulse" />
              <span className="text-xs md:text-sm font-caption text-muted-foreground tracking-wide">
                SYSTEM STATUS: ONLINE
              </span>
            </div>
            <p className="text-xs md:text-sm font-caption text-muted-foreground leading-relaxed">
              Welcome back, Cyber Warrior. Your psychological gaming journey continues. The AI opponents are evolving based on your performance. Current difficulty scaling is active. Gem rarity has increased due to your winning streak. New AI moods await unlock. Prepare for intense mind games.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MainMenu;